export const transition300ms = 'transform 300ms ease-in-out';
